import React, {useState, useEffect, useContext, useRef} from "react";
import {Modal, Button, Form} from "react-bootstrap";
import {FaEdit, FaPlus, FaRedo, FaTrash} from "react-icons/fa";
import {ToastContext} from "../App";
import axios from "axios";

export default function MembersPage() {
    const [members, setMembers] = useState([]);
    const [show, setShow] = useState(false);
    const [editingIndex, setEditingIndex] = useState(null);
    const [formData, setFormData] = useState({
        fullName: "",
        subscription_type: "",
        subscription_valid_until: "",
        dob: "",
        age: "",
        phone: "",
        password: "", // أضف هنا
        weight: "",
        height: "",
        smoker: "لا", // قيمة افتراضية
        goal: "",
        notes: "",
        start_date: "",

    });

    const [showDelete, setShowDelete] = useState(false);
    const [deleteIndex, setDeleteIndex] = useState(null);
    const showToast = useContext(ToastContext);
    const isFetching = React.useRef(false);
    const [searchTerm, setSearchTerm] = useState("");
    const tableContainerRef = useRef(null);
    const [newStartDate, setNewStartDate] = useState("");



    const API_URL = `${process.env.REACT_APP_BACKEND_URL}/api/members`;

    const [showRenew, setShowRenew] = useState(false);
    const [currentMember, setCurrentMember] = useState(null);
    const [subscriptions, setSubscriptions] = useState([]);
    const [newSubscriptionType, setNewSubscriptionType] = useState("");

    const getAuthHeaders = () => {
        const token = localStorage.getItem("FORCE_GYM_TOKEN");
        return {headers: {Authorization: `Bearer ${token}`}};
    };


    useEffect(() => {
        fetchMembers();
    }, []);

    const fetchMembers = async () => {
        if (isFetching.current) return;
        isFetching.current = true;
        try {
            const res = await axios.get(API_URL);
            setMembers(
                res.data.map((m) => ({
                    id: m.id,
                    fullName: m.full_name,
                    dob: m.birth_date ? m.birth_date.split('T')[0] : "",
                    age: m.age,
                    phone: m.phone,
                    password: m.password,
                    weight: m.weight,
                    height: m.height,
                    smoker: m.smoker || "لا",
                    goal: m.goal || "",
                    notes: m.health_notes || "",
                    subscription_type: m.subscription_type || "",
                    subscription_valid_until: m.subscription_valid_until || "",
                    start_date: m.start_date ? m.start_date.split('T')[0] : "",
                    profile_image: m.profile_image || null,
                }))
            );
        } catch (err) {
            console.error(err);
        } finally
        {
            isFetching.current = false;
        }
    };

    const handleClose = () => {
        setShow(false);
        setEditingIndex(null);
        setFormData({
            fullName: "",
            dob: "",
            age: "",
            phone: "",
            weight: "",
            height: "",
            smoker: "لا",
            goal: "",
            notes: "",
            subscription_type: "",
        });
    };

    const handleShow = () => setShow(true);

    const calculateAge = (dob) => {
        if (!dob) return "";
        const birthDate = new Date(dob);
        const today = new Date();
        let age = today.getFullYear() - birthDate.getFullYear();
        const monthDiff = today.getMonth() - birthDate.getMonth();
        if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
            age--;
        }
        return age;
    };

    const handleChange = (e) => {
        const {name, value} = e.target;
        let updatedData = {...formData, [name]: value};

        if (name === "dob") {
            updatedData.age = calculateAge(value);
        }

        setFormData(updatedData);
    };

    const handleSave = async () => {
        const {fullName, subscription_type, dob, phone, password, weight, height} = formData;
        // جميع الحقول المطلوبة + password عند الإنشاء
        if (!fullName || !subscription_type || !dob || !phone || !weight || !height || (editingIndex === null && !password)) {
            showToast("يرجى ملء جميع الحقول المطلوبة!", "danger");
            return;
        }

        try {
            if (editingIndex !== null) {
                // تحديث عضو بدون كلمة المرور
                await axios.put(`${API_URL}/${filteredMembers[editingIndex].id}`, {
                    full_name: formData.fullName,
                    subscription_type: formData.subscription_type,
                    birth_date: formData.dob,
                    phone: formData.phone,
                    weight: formData.weight,
                    height: formData.height,
                    smoker: formData.smoker,
                    goal: formData.goal,
                    health_notes: formData.notes,
                    start_date: formData.start_date,
                }, getAuthHeaders());
            } else {
                // إضافة عضو جديد مع كلمة المرور
                await axios.post(API_URL, {
                    full_name: formData.fullName,
                    subscription_type: formData.subscription_type,
                    birth_date: formData.dob,
                    phone: formData.phone,
                    password: formData.password,
                    weight: formData.weight,
                    height: formData.height,
                    smoker: formData.smoker,
                    goal: formData.goal,
                    health_notes: formData.notes,
                    start_date: formData.start_date,
                }, getAuthHeaders());
            }
            fetchMembers();
            handleClose();
            showToast("تم حفظ البيانات بنجاح!", "success");
        } catch (err) {
            console.error(err);
            // التحقق من رسالة الهاتف المكرر
            if (err.response && err.response.data && err.response.data.message) {
                showToast(err.response.data.message, "danger");
            } else {
                showToast("حدث خطأ أثناء الحفظ!", "danger");
            }
        }
    };

    const handleEdit = (index) => {
        const member = filteredMembers[index];
        setEditingIndex(index);
        setFormData({
            fullName: member.fullName,
            subscription_type: member.subscription_type,
            dob: member.dob,
            age: member.age,
            phone: member.phone,
            weight: member.weight,
            height: member.height,
            smoker: member.smoker || "لا",
            goal: member.goal || "",
            notes: member.notes || "",
            start_date: member.start_date,
        });
        setShow(true);
    };

    const handleDelete = async () => {
        try {
            await axios.delete(`${API_URL}/${filteredMembers[deleteIndex].id}`, getAuthHeaders());
            fetchMembers();
            setShowDelete(false);
            showToast("تم حذف العضو بنجاح!", "success");
        } catch (err) {
            console.error(err);
            showToast("حدث خطأ أثناء الحذف!", "danger");
        }
    };

    // Filter members based on searchTerm
    const filteredMembers = members.filter((m) =>
        Object.values(m).some((value) =>
            value?.toString().toLowerCase().includes(searchTerm.toLowerCase())
        )
    );

    // Function to open renew modal and fetch old subscriptions
    const handleRenew = async (member) => {
        setCurrentMember(member);
        setNewSubscriptionType("");
        try {
            const res = await axios.get(`${API_URL}/${member.id}/subscriptions`, getAuthHeaders());
            setSubscriptions(res.data);
            setShowRenew(true);
        } catch (err) {
            console.error(err);
            showToast("حدث خطأ أثناء جلب الاشتراكات", "danger");
        }
    };

// Function to save new subscription
    const handleSaveRenew = async () => {
        if (!newSubscriptionType) {
            showToast("اختر نوع الاشتراك الجديد", "danger");
            return;
        }
        try {
            await axios.post(`${API_URL}/${currentMember.id}/subscriptions`, {
                subscription_type: newSubscriptionType ,
                start_date: newStartDate || null
            }, getAuthHeaders());
            setShowRenew(false);
            fetchMembers(); // refresh table
            showToast("تم تجديد الاشتراك بنجاح!", "success");
        } catch (err) {
            console.error(err);
            showToast(err.response.data.message, "danger");
        }
    };

    useEffect(() => {
        if (tableContainerRef.current) {

            tableContainerRef.current.scrollLeft = tableContainerRef.current.scrollWidth;
        }
    }, [filteredMembers]);


    return (
        <div className={"content"}>
            <div className="container  mt-5">
                <h2 className="text-center mb-4">إدارة الأعضاء</h2>
                <div className="d-flex justify-content-between mb-3">
                    <input
                        type="text"
                        className="form-control w-25 text-end"
                        placeholder="ابحث في الأعضاء..."
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                    />
                    <Button variant="success" onClick={handleShow}>+ إضافة عضو</Button>

                </div>


                <div
                    ref={tableContainerRef}
                    style={{overflowX: "auto", maxHeight: "650px"}}>
                    <table
                        className="table table-hover table-bordered table-striped align-middle  shadow rounded text-center"
                        style={{
                            minWidth: "1700px",
                            borderCollapse: "separate",
                            borderSpacing: "0",
                        }}
                    >
                        <thead style={{backgroundColor: "#1E3A8A", color: "white"}}>
                        <tr>
                            <th>#</th>
                            <th>الاسم الكامل</th>
                            <th>نوع الاشتراك</th>
                            <th>تاريخ الميلاد</th>
                            <th>العمر</th>
                            <th>رقم الهاتف</th>
                            <th>رقم المرور</th>
                            <th>الوزن</th>
                            <th>الطول</th>
                            <th>مدخن</th>
                            <th>الهدف من التمرين</th>
                            <th>ملاحظات</th>
                            <th>إجراءات</th>
                        </tr>
                        </thead>
                        <tbody>
                        {filteredMembers.length > 0 ? (
                            filteredMembers.map((m, i) => (
                                <tr
                                    key={m.id}
                                    style={{
                                        backgroundColor: i % 2 === 0 ? "#F3F4F6" : "#FFFFFF",
                                        fontSize: "16px",
                                    }}
                                >
                                    <td>{i + 1}</td>
                                    <td className="d-flex align-items-center justify-content-end gap-2 flex-row-reverse">
                                        <span>{m.fullName}</span>
                                        <img
                                            src={`${process.env.REACT_APP_BACKEND_URL}/profile/${m.profile_image || "default-profile.jpeg"}`}
                                            alt="profile"
                                            style={{
                                                width: "45px",
                                                height: "45px",
                                                borderRadius: "50%",
                                                objectFit: "cover",
                                                border: "2px solid #ddd",
                                                boxShadow: "0 0 6px rgba(0,0,0,0.15)",
                                                marginLeft: "8px",
                                                cursor: "pointer",
                                            }}
                                            onClick={() => window.location.href = `/admin/member-home/${m.id}`}

                                        />

                                    </td>

                                    <td>
                                        {(() => {
                                            if (!m.subscription_type || !m.subscription_valid_until || m.subscription_valid_until === "null") {
                                                return <span className="badge bg-secondary">لا يوجد اشتراك</span>;
                                            }

                                            const validUntil = new Date(m.subscription_valid_until);
                                            const today = new Date();
                                            validUntil.setHours(0, 0, 0, 0);
                                            today.setHours(0, 0, 0, 0);

                                            const diffDays = Math.ceil((validUntil - today) / (1000 * 60 * 60 * 24));

                                            let badgeVariant = "";
                                            let bgColor = "";
                                            let statusText = "";

                                            if (diffDays < 0) {
                                                bgColor = "#EF4444";
                                                statusText = "منتهي";
                                            } else if (diffDays <= 7) {
                                                bgColor = "#F59E0B";
                                                statusText = `متبقي ${diffDays} يوم`;
                                            } else {
                                                bgColor = "#10B981";
                                                statusText = `متبقي ${diffDays} يوم`;
                                            }

                                            return (
                                                <span style={{
                                                    backgroundColor: bgColor,
                                                    color: "white",
                                                    padding: "5px 10px",
                                                    borderRadius: "12px",
                                                    fontSize: "14px",
                                                    display: "inline-block"
                                                }}>
                    {m.subscription_type} - {validUntil.toLocaleDateString("ar-EG")} ({statusText})
                  </span>
                                            );
                                        })()}
                                    </td>
                                    <td>{m.dob}</td>
                                    <td>{m.age}</td>
                                    <td>{m.phone}</td>
                                    <td>{m.password}</td>
                                    <td>{m.weight}</td>
                                    <td>{m.height}</td>
                                    <td>{m.smoker}</td>
                                    <td>{m.goal}</td>
                                    <td>{m.notes}</td>
                                    <td>
                                        <FaPlus
                                            style={{cursor: "pointer", color: "green", marginRight: "10px"}}
                                            size={20}
                                            title="تجديد الاشتراك"
                                            onClick={() => handleRenew(m)}
                                        />
                                        <FaEdit
                                            style={{cursor: "pointer", color: "blue", marginRight: "10px"}}
                                            size={20}
                                            title="تعديل العضو"
                                            onClick={() => handleEdit(i)}
                                        />
                                        <FaTrash
                                            style={{cursor: "pointer", color: "red", marginRight: "10px"}}
                                            size={20}
                                            title="حذف العضو"
                                            onClick={() => {
                                                setDeleteIndex(i);
                                                setShowDelete(true);
                                            }}
                                        />
                                    </td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan="13">لا يوجد أعضاء مطابقين للبحث</td>
                            </tr>
                        )}
                        </tbody>
                    </table>
                </div>

                {/* Modal لإضافة / تعديل عضو */}
                <Modal
                    show={show}
                    onHide={handleClose}
                    centered
                    size="xl"
                >
                    <Modal.Header>
                        <Modal.Title>
                            {editingIndex !== null ? "تعديل العضو" : "إضافة عضو جديد"}
                        </Modal.Title>
                    </Modal.Header>

                    <Modal.Body style={{backgroundColor: "#f8f9fa"}}>
                        <Form>
                            {/* Hidden fake password to trick browser */}
                            <input
                                type="password"
                                name="fakepassword"
                                autoComplete="new-password"
                                style={{display: "none"}}
                            />

                            {/* Row 1: Full Name + Phone */}
                            <div className="row mb-3">
                                <div className="col-md-6 col-sm-12">
                                    <Form.Label>الاسم الكامل</Form.Label>
                                    <Form.Control
                                        type="text"
                                        name="fullName"
                                        value={formData.fullName}
                                        onChange={handleChange}
                                        required
                                    />
                                </div>

                                <div className="col-md-6 col-sm-12">
                                    <Form.Label>رقم الهاتف</Form.Label>
                                    <Form.Control
                                        type="text"
                                        name="phone"
                                        value={formData.phone}
                                        onChange={handleChange}
                                        required
                                    />
                                </div>
                            </div>

                            {/* Row 2: Subscription type + Start date */}

                                    <div className="row mb-3">
                                        <div className="col-md-6 col-sm-12">
                                            <Form.Label>نوع الاشتراك</Form.Label>
                                            <Form.Select
                                                name="subscription_type"
                                                value={formData.subscription_type}
                                                onChange={handleChange}
                                                required
                                            >
                                                <option value="">اختر نوع الاشتراك</option>
                                                <option value="شهري">شهري</option>
                                                <option value="3 شهور">3 شهور</option>
                                                <option value="6 شهور">6 شهور</option>
                                                <option value="سنة">سنة</option>
                                            </Form.Select>
                                        </div>

                                        <div className="col-md-6 col-sm-12">
                                            <Form.Label>تاريخ بداية الاشتراك (اختياري)</Form.Label>
                                            <Form.Control
                                                type="date"
                                                name="start_date"
                                                value={formData.start_date || ""}
                                                onChange={handleChange}
                                                className="text-end"
                                            />
                                        </div>
                                    </div>
                            {editingIndex === null && (
                                <>
                                    {/* Row 3: Password */}
                                    <div className="row mb-3">
                                        <div className="col-md-6 col-sm-12">
                                            <Form.Label>كلمة المرور</Form.Label>
                                            <Form.Control
                                                type="password"
                                                name="password"
                                                value={formData.password}
                                                onChange={handleChange}
                                                required
                                            />
                                        </div>
                                    </div>
                                    <hr className="my-4" style={{ borderTop: "3px solid #ccc" }} />

                                </>
                            )}


                            {/* Row 4: Date of birth + Age */}
                            <div className="row mb-3">
                                <div className="col-md-6 col-sm-12">
                                    <Form.Label>تاريخ الميلاد</Form.Label>
                                    <Form.Control
                                        type="date"
                                        name="dob"
                                        value={formData.dob}
                                        onChange={handleChange}
                                        required
                                        className="text-end"
                                    />
                                </div>
                                <div className="col-md-6 col-sm-12">
                                    <Form.Label>العمر</Form.Label>
                                    <Form.Control
                                        type="text"
                                        name="age"
                                        value={formData.age}
                                        disabled
                                        className="bg-light"
                                    />
                                </div>
                            </div>

                            {/* Row 5: Weight + Height */}
                            <div className="row mb-3">
                                <div className="col-md-6 col-sm-12">
                                    <Form.Label>الوزن (كجم)</Form.Label>
                                    <Form.Control
                                        type="number"
                                        name="weight"
                                        value={formData.weight}
                                        onChange={handleChange}
                                        required
                                    />
                                </div>
                                <div className="col-md-6 col-sm-12">
                                    <Form.Label>الطول (سم)</Form.Label>
                                    <Form.Control
                                        type="number"
                                        name="height"
                                        value={formData.height}
                                        onChange={handleChange}
                                        required
                                    />
                                </div>
                            </div>

                            {/* Row 6: Smoker */}
                            <div className="row mb-3">
                                <div className="col-md-6 col-sm-12">
                                    <Form.Label>هل أنت مدخن؟</Form.Label>
                                    <div>
                                        <Form.Check
                                            inline
                                            label="نعم"
                                            name="smoker"
                                            type="radio"
                                            value="نعم"
                                            checked={formData.smoker === "نعم"}
                                            onChange={handleChange}
                                        />
                                        <Form.Check
                                            inline
                                            label="لا"
                                            name="smoker"
                                            type="radio"
                                            value="لا"
                                            checked={formData.smoker === "لا"}
                                            onChange={handleChange}
                                        />
                                    </div>
                                </div>
                            </div>

                            {/* Row 7: Goal + Notes */}
                            <div className="row mb-3">
                                <div className="col-md-6 col-sm-12">
                                    <Form.Label>الهدف من التمرين</Form.Label>
                                    <Form.Control
                                        type="text"
                                        name="goal"
                                        value={formData.goal}
                                        onChange={handleChange}
                                    />
                                </div>
                                <div className="col-md-6 col-sm-12">
                                    <Form.Label>ملاحظات</Form.Label>
                                    <Form.Control
                                        as="textarea"
                                        rows={2}
                                        name="notes"
                                        value={formData.notes}
                                        onChange={handleChange}
                                    />
                                </div>
                            </div>
                        </Form>
                    </Modal.Body>

                    <Modal.Footer>
                        <Button variant="secondary" onClick={handleClose}>إلغاء</Button>
                        <Button variant="success" onClick={handleSave}>
                            {editingIndex !== null ? "حفظ التغييرات ✅" : "إضافة ✅"}
                        </Button>
                    </Modal.Footer>
                </Modal>

                {/* Modal لتأكيد الحذف */}
                <Modal show={showDelete} onHide={() => setShowDelete(false)} centered>
                    <Modal.Header>
                        <Modal.Title>تأكيد الحذف</Modal.Title>
                    </Modal.Header>
                    <Modal.Body className="text-center">
                        <p>هل أنت متأكد أنك تريد حذف هذا العضو؟</p>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={() => setShowDelete(false)}>إلغاء</Button>
                        <Button variant="danger" onClick={handleDelete}>نعم، حذف</Button>
                    </Modal.Footer>
                </Modal>

                {/* Modal لتجديد الاشتراك */}
                <Modal show={showRenew} onHide={() => setShowRenew(false)} size="lg" centered>
                    <Modal.Header closeButton>
                        <Modal.Title>تجديد الاشتراك - {currentMember?.fullName}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <p>رقم الهاتف: {currentMember?.phone}</p>

                        <h5>الاشتراكات السابقة</h5>
                        <table className="table table-bordered">
                            <thead>
                            <tr>
                                <th>نوع الاشتراك</th>
                                <th>تاريخ البداية</th>
                                <th>تاريخ النهاية</th>
                            </tr>
                            </thead>
                            <tbody>
                            {subscriptions.map((s) => (
                                <tr key={s.id}>
                                    <td>{s.subscription_type}</td>
                                    <td>{new Date(s.start_date).toLocaleDateString("ar-EG")}</td>
                                    <td>{new Date(s.end_date).toLocaleDateString("ar-EG")}</td>
                                </tr>
                            ))}
                            </tbody>
                        </table>

                        <Form.Group className="mt-3">
                            <Form.Label>نوع الاشتراك الجديد</Form.Label>
                            <Form.Select
                                value={newSubscriptionType}
                                onChange={(e) => setNewSubscriptionType(e.target.value)}
                            >
                                <option value="">اختر نوع الاشتراك</option>
                                <option value="شهري">شهري</option>
                                <option value="3 شهور">3 شهور</option>
                                <option value="6 شهور">6 شهور</option>
                                <option value="سنة">سنة</option>
                            </Form.Select>
                        </Form.Group>

                        <Form.Group className="mt-3">
                            <Form.Label>تاريخ بداية الاشتراك الجديد (اختياري)</Form.Label>
                            <Form.Control
                                type="date"
                                value={newStartDate || ""}
                                onChange={(e) => setNewStartDate(e.target.value)}
                                className="text-end"
                            />
                        </Form.Group>

                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={() => setShowRenew(false)}>إلغاء</Button>
                        <Button variant="primary" onClick={handleSaveRenew}>تجديد</Button>
                    </Modal.Footer>
                </Modal>

            </div>
        </div>

    );
}
